import { Action, AnyAction } from "@reduxjs/toolkit";

export interface CounterState {
  value: number;
}
export enum SentinelLoadingStatus {
  STARTED = "STARTED",
  LOADING = "LOADING",
  FINISHED = "FINISHED",
  REJECTED = "REJECTED",
}

export interface SentinelEvent<T> {
  status: SentinelLoadingStatus;
  payload: T;
}

export interface OnboardedTeam {
  requesterId: string;
  teamEmail: string;
  teamId: string;
  teamName: string;
  crCount: number;
  crLimit: number;
  pipelinesOnboardedCount: number;
}

export interface OnboardedTeamResponse {
  payload: {
    payload: {
      onboardedTeams: OnboardedTeam[];
    };
  }
}

export interface MonitoredPipeline {
  pipelineName: string;
  teamId: string;
  teamName: string;
  teamEmail: string;
  packageCount: number;
}

export interface MonitoredPipelineResponse {
  payload: {
    payload: {
      pipelines: MonitoredPipeline[];
    };
  }
}

export interface TeamPackage {
  packageName: string;
  pipelineName: string;
  teamName: string;
  teamId: string;
  packageMajorVersion: string;
  versionSet: string;
  packageBranch: string;
}

export interface TeamPackageListResponse {
  payload: {
    payload: {
      teamPackageList: TeamPackage[];
    };
  }
}

export interface PipelinePackagesResponse {
  payload: {
    payload: {
      packages: TeamPackage[];
    };
  }
}

export interface CodeReview {
  codeReviewId: string;
  packageName: string;
  status: string;
  teamId: string;
  dependencyName: string;
  upgradeVersionFrom: string;
  upgradeVersionTo: string;
  createdAt: string;
}

export interface CodeReviewListResponse {
  payload: {
    payload: {
      codeReviewList: CodeReview[];
    };
  }
}

export interface PackageDependency {
  version: string;
  packageName: string;
  dependencyName: string;
  vendorGuidanceStatus: string;
  recommendedVersion: string;
  riskStatus: string;
}


export interface PackageDependencyListResponse {
  payload: {
    payload: {
      packageDependencyList: PackageDependency[];
    };
  }
}

export function createEvent<T>(payload: T): SentinelEvent<T> {
    return {
        status: SentinelLoadingStatus.STARTED,
        payload: payload,
    };
}

export interface DependencyUpgradeRecommendation {
  dependencyName: string;
  currentVersion: string;
  currentVersionStatus: string;
  upgradableVersion: string;
  upgradeRecommendation: string;
}

export interface DryRunResult {
  requestId: string;
  packageName: string;
  latestRelease: string;
  status: string;
  totalRecommendations: number;
  dependencyUpgradeRecommendations: DependencyUpgradeRecommendation[];
  errorMessage?: string;
}

export interface ApiError extends Action {
  message: string;
  error: Error;
}
export function isApiError(action: AnyAction): action is ApiError {
    return action.type.endsWith("rejected");
}
